import { render, staticRenderFns } from "./QuickSightEmbed.vue?vue&type=template&id=1a5bdc10&scoped=true&"
import script from "./QuickSightEmbed.vue?vue&type=script&lang=js&"
export * from "./QuickSightEmbed.vue?vue&type=script&lang=js&"
import style0 from "./QuickSightEmbed.vue?vue&type=style&index=0&id=1a5bdc10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bdc10",
  null
  
)

export default component.exports